import { TypeAheadFilter } from './TypeAheadFilter';
import { TableFilterTypeAheadFilterExtendedProps } from '@components/table/filters/TypeaheadFilterProps.type';
import { ReportingQuoteSourceLabels, REPORTING_QUOTE_SOURCE_NONE_FILTER } from '@models/quotes';

export interface ReportingQuoteSourceTypeaheadFilterProps extends TableFilterTypeAheadFilterExtendedProps {}

const options = [
  ...Object.entries(ReportingQuoteSourceLabels).map(([value, label]) => ({
    key: value,
    label,
    value,
  })),
  {
    key: REPORTING_QUOTE_SOURCE_NONE_FILTER,
    label: '(No Source)',
    value: REPORTING_QUOTE_SOURCE_NONE_FILTER,
  },
];

export const ReportingQuoteSourceTypeaheadFilter = (componentProps: ReportingQuoteSourceTypeaheadFilterProps) => {
  const { value, disabled } = componentProps;

  return (
    <TypeAheadFilter
      value={value}
      defaultValue={value}
      disabled={disabled}
      label={componentProps.label}
      options={options}
      isMultiple={componentProps?.fieldConfig?.selectField?.multiSelect}
      limitTags={1}
      onChange={componentProps.onChange}
      horizontalLabel={true}
    />
  );
};
